<se-fe-page
  seFeDataWidth="full"
  [seFeDataLoaded]="ready">
  <se-fe-header seFePageHeader
    seFeDataSize="750"
    seFeDataTitle="Household">
  </se-fe-header>
  <div seFePageContent>
    <div class="household-avatars" *ngIf="ready">
      <se-po-duplicate-banner [profiles]="profiles" (merge)="onMerge($event, 'from_banner')">
      </se-po-duplicate-banner>
      <div *ngIf="selfProfile" class="household-avatar">
        <se-po-household-avatar
          seFeSidePanelTrigger
          [profile]="selfProfile"
          (chosen)="onChosen($event)"
          (remove)="onRemove($event)">
        </se-po-household-avatar>
      </div>
      <div *ngFor="let profile of otherProfiles"
        class="household-avatar">
        <se-po-household-avatar
          seFeSidePanelTrigger
          [profile]="profile"
          [profiles]="otherProfiles"
          (chosen)="onChosen($event)"
          (merge)="onMerge($event)"
          (remove)="onRemove($event)">
        </se-po-household-avatar>
      </div>
    </div>
    <se-po-household-side-panel #householdSidePanel
      [(personaId)]="selectedPersonaId"
      [profiles]="profiles"
      (edit)="onEdit($event)"
      (merge)="onMerge($event, 'from_modal')"
      (personaEdited)="onPersonaEdit($event)"
      (remove)="onRemove($event)">
    </se-po-household-side-panel>
  </div>
</se-fe-page>
<se-po-edit-persona-modal #editPersonaModal
  seFeSidePanelTrigger
  (personaEdited)="onPersonaEdit($event)">
</se-po-edit-persona-modal>
<se-po-remove-persona-modal #removePersonaModal
  seFeSidePanelTrigger
  (personaRemoved)="onPersonaRemove($event)">
</se-po-remove-persona-modal>
<se-po-merge-persona-modal #mergePersonaModal
  seFeSidePanelTrigger
  (personaMerged)="onPersonaRemove($event)">
</se-po-merge-persona-modal>
